export default "/_next/static/videos/f70fbf9cc9de161b655a98c9f71ba379.mp4";